import Vue from 'vue'
import { date } from 'quasar'
Vue.filter('formatDate', function (value) {
    if (value) {
        return date.formatDate(value, 'YYYY-MM-DD')
    } else {
        return ''
    }
})
Vue.filter('toFixed2', function (value) {
    if (value) {
        return (Math.round(value * 100) / 100).toFixed(2)
    } else {
        return 0
    }
})

Vue.filter('formatBytes', function (bytes) {
    if (bytes) {
        if (bytes === 0) return '0 B'
        var k = 1000, // or 1024
            sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k)) //向下取整，用于判断是什么单位

        return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i]
    } else {
        return ''
    }
})
